import { Button } from 'antd';
import React from 'react';

interface Props {
    handleClickShowPreviousParts: () => void;
}

const ButtonAddPreviousQuotedParts = (props: Props) => {
    return (
        <Button
            type="primary"
            className="master-product-action-button"
            onClick={props.handleClickShowPreviousParts}
        >
            Add a previously quoted product
        </Button>
    );
};

export default ButtonAddPreviousQuotedParts;
